module.exports = __webpack_public_path__ + "img/nav6.a3301c2e.png";